<template>
    <div>
        <template v-if="translations">

            <template v-if="translations.length !== 0">

                <template v-for="(translation, index) in translations">


                    <b-card no-body :key="`${index}`">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <div
                                    class="p-2 px-3 d-flex justify-content-between align-items-center"
                                    v-b-toggle="`translation-${translation.locale}`"
                            >
                                <div :style="!translation.locale ? 'opacity: 0': ''">
                                    {{translation.locale ? translation.locale.toUpperCase(): 'EN'}}
                                </div>

                                <div class="m-auto">
                                    <code>
                                        <small class="text-muted">
                                            Click on me to Open/Close
                                        </small>
                                    </code>
                                </div>

                                <b-button
                                        size="sm"
                                        variant="danger"
                                        @click="removeTranslation(index)"
                                >
                                    <i class="fa fa-trash"></i>
                                </b-button>

                            </div>
                        </b-card-header>
                        <template slot="header">
                        </template>

                        <b-collapse :id="`translation-${translation.locale}`"
                                    :visible="collapseVisible(translation, index)" class="mt-2">
                            <b-card-body>

                                <b-form>
                                    <template v-for="(value, field) in translation">
                                        <b-form-group
                                                v-if="!hideFields(field)"
                                                :key="`${index}${field}`"
                                                :label="transformLabel(field)"
                                                :label-for="field"
                                        >
                                            <b-form-textarea
                                                    v-if="field === 'description'"
                                                    :id="field"
                                                    v-validate="field === 'locale' ? 'required|length:2' : 'required'"
                                                    v-model="translation[field]"
                                                    :name="generateName(transformLabel(field), index)"
                                                    :class="{'form-control':true, 'is-invalid':invalidValue(generateName(transformLabel(field), index))}"
                                                    :data-vv-as="field"
                                                    type="text"
                                            />

                                            <b-form-select
                                                    v-else-if="field === 'locale'"
                                                    :id="field"
                                                    v-validate="'required'"
                                                    v-model="translation[field]"
                                                    :options="getLanguages"
                                                    name="translation"
                                                    type="text"
                                                    placeholder="Pick language"
                                            />

                                            <b-form-input
                                                    v-else
                                                    :id="field"
                                                    v-validate="'required'"
                                                    v-model="translation[field]"
                                                    :name="generateName(transformLabel(field), index)"
                                                    :class="{'form-control':true, 'is-invalid':invalidValue(generateName(transformLabel(field), index))}"
                                                    :data-vv-as="field"
                                                    type="text"
                                            />
                                        </b-form-group>
                                    </template>
                                </b-form>

                            </b-card-body>
                        </b-collapse>
                    </b-card>

                </template>

            </template>

            <template v-else>
                <b-input-group-text class="text-center mb-4">
                    <div class="ml-auto mr-auto">
                        Here are no translations
                        <br>
                        Add translation using the "Add Translation" button below.
                    </div>
                </b-input-group-text>
            </template>

        </template>

        <b-button block variant="primary" @click="addNewTranslation()">
            Add Translation
        </b-button>
    </div>
</template>

<script>
    import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
    import cloneObject from "@/libs/cloneObject";
    import { TRANSLATIONS } from "@/constants";

    export default {
        name: 'TranslationForm',
        inject: ['$validator'],
        props: {
            translations: {
                required: false,
                type: Array | Object,
            },
            newTranslationItem: {
                required: false,
                type: Object,
            },
        },
        computed: {
            getLanguages() {
                return TRANSLATIONS;
            }
        },
        methods: {
            addNewTranslation() {
                this.translations.push(cloneObject(this.newTranslationItem))
            },

            removeTranslation(index) {
                const approveRemove = confirm('Вы уверены что хотите удалить Перевод?');

                if (approveRemove) {
                    this.translations.splice(index, 1);
                }
            },

            collapseVisible(translation, index) {
                return !translation.id || index === 0;
            },

            invalidValue(fieldName) {
                return this.$validator.errors.has(fieldName);
            },

            transformLabel(field) {
                return capitalizeFirstLetter(field);
            },

            generateName(field, index) {
                return `${field}${index}`;
            },

            validateTranslations() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('validateForm');
                    }
                });
            },

            hideFields(field) {
                const fields = [
                    'createdAt',
                    'updatedAt',
                    'id',
                ];
        
                return fields.includes(field);
            }
        },
    }
</script>
<style lang="scss">
    .form-group #locale {
        text-transform: uppercase;
    }
</style>
